module.exports = function getRatio() {
  return window.devicePixelRatio ? window.devicePixelRatio : 2;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/dom/get-ratio.js
// module id = 272
// module chunks = 0 1 2